export default {
  /**
   * 问卷管理
   */
  adminSurveyList: `/api/dwsurvey/admin/survey/list.do`,
  adminSurveyDelete: `/api/dwsurvey/admin/survey/delete.do`,

  /**
   * 场景管理
   */
  adminSurveyGroupList: `/api/dwsurvey/admin/survey-group/list.do`,
  adminSurveyGroupCreate: `/api/dwsurvey/admin/survey-group/add.do`,
  adminSurveyGroupUpdate: `/api/dwsurvey/admin/survey-group/edit.do`,
  adminSurveyGroupDelete: `/api/dwsurvey/admin/survey-group/delete.do`,
  surveyGroupList: `/api/dwsurvey/survey-group-list.do`,

  /**
   * 背景管理
   */
  adminSurveyBackgroundList: `/api/dwsurvey/admin/survey-background/list.do`,
  adminSurveyBackgroundCreate: `/api/dwsurvey/admin/survey-background/add.do`,
  adminSurveyBackgroundUpdate: `/api/dwsurvey/admin/survey-background/edit.do`,
  adminSurveyBackgroundDelete: `/api/dwsurvey/admin/survey-background/delete.do`,
  surveyBackgroundNameOptions: `/api/dwsurvey/admin/survey-background/all/name`,
  surveyBackgroundUpload: `/api/dwsurvey/admin/tencent/handler/images`,

  /**
   * 模板管理
   */
  adminSurveyTemplaterList: `/api/dwsurvey/admin/survey-template/list.do`,
  adminSurveyTemplaterCreate: `/api/dwsurvey/admin/survey-template/add.do`,
  adminSurveyTemplaterUpdate: `/api/dwsurvey/admin/survey-template/edit.do`,
  adminSurveyTemplaterDelete: `/api/dwsurvey/admin/survey-template/delete.do`,

  /**
   * 级联数据管理
   */
  adminCascadeList: `/api/dwsurvey/admin/cascade/list.do`,
  adminCascadeCreate: `/api/dwsurvey/admin/cascade/add.do`,
  adminCascadeUpdate: `/api/dwsurvey/admin/cascade/edit.do`,
  adminCascadeDelete: `/api/dwsurvey/admin/cascade/delete.do`,

  /**
   * 用户管理
   */
  adminUserList: `/api/dwsurvey/admin/user/list.do`,
  adminUserCreate: `/api/dwsurvey/admin/user/add.do`,
  adminUserUpdate: `/api/dwsurvey/admin/user/edit.do`,
  adminUserDelete: `/api/dwsurvey/admin/user/delete.do`,

  adminUserDept: `/api/dwsurvey/admin/user/user-dept.do`,
  adminUserRole: `/api/dwsurvey/admin/user/user-role.do`,
  adminResetLogin: `/api/dwsurvey/admin/user/reset-login.do`,
  adminResetLoginPwd: `/api/dwsurvey/admin/user/reset-login-pwd.do`,
  adminResetAllLoginPwd: `/api/dwsurvey/admin/user/reset-all-login-pwd.do`,
  /**
   * 部门管理
   */
  adminDeptList: `/api/dwsurvey/admin/dept/list.do`,
  adminDeptCreate: `/api/dwsurvey/admin/dept/add.do`,
  adminDeptUpdate: `/api/dwsurvey/admin/dept/edit.do`,
  adminDeptDelete: `/api/dwsurvey/admin/dept/delete.do`,

  adminDeptPath: `/api/dwsurvey/admin/dept/dept-path.do`,

  /**
   * 角色管理
   */
  adminRoleList: `/api/dwsurvey/admin/role/list.do`,
  adminRoleCreate: `/api/dwsurvey/admin/role/add.do`,
  adminRoleUpdate: `/api/dwsurvey/admin/role/edit.do`,
  adminRoleDelete: `/api/dwsurvey/admin/role/delete.do`,
  adminAllRole: `/api/dwsurvey/admin/role/all-role.do`,

  adminRolePerm: `/api/dwsurvey/admin/role/role-perm.do`,

  /**
   * 权限管理
   */
  adminPermList: `/api/dwsurvey/admin/perm/perm.do`,
  adminAllPerm: `/api/dwsurvey/admin/perm/all-perm.do`,
  /**
   * 日志管理
   */
  adminLogList: `/api/dwsurvey/admin/log/log.do`,

  adminAnalysis: `/api/dwsurvey/admin/analysis.do`,
  adminQueryDsb: `/api/dwsurvey/app/stats/dsb.do`,

  provinceAnswer: `/api/dwsurvey/app/stats/province-answer-page.do`,
  getCountry: `/api/dwsurvey/app/stats/get-country.do`,
  adminSurveyState: `/api/dwsurvey/admin/survey-state.do`,
  adminSurveyCity: `/api/dwsurvey/admin/survey-city.do`,

  getApp: `/api/ads/getApp.do`
}



// WEBPACK FOOTER //
// ./src/api/dw-admin/index.js